import { render, staticRenderFns } from "./AddBranch.vue?vue&type=template&id=01990693&scoped=true&"
import script from "./AddBranch.vue?vue&type=script&lang=js&"
export * from "./AddBranch.vue?vue&type=script&lang=js&"
import style0 from "./AddBranch.vue?vue&type=style&index=0&id=01990693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01990693",
  null
  
)

export default component.exports